export const pusherSubscription = {
  EVENT: 'pusher:subscription_succeeded',
  TIMEOUT: 2000, // 2 seconds
};
